// extracted by mini-css-extract-plugin
export default {"textArea":"TextDescription_textArea__UEVxc"};